import { API_BASE_URL } from "src/config/api";
import { useState, useEffect } from 'react';
import axios from 'axios';

const useAccount = () => {
  const [account, setAccount] = useState({
    displayName: '',
    email: '',
    photoURL: '/assets/images/avatars/usericon4.jpeg', 
    isOldUser: true,
  });

  useEffect(() => {
    const fetchUserData = async () => {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');

      if (token && userId) {
        try {
          const config = {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          };

          const response = await axios.get(`${API_BASE_URL}/getUserById?userId=${userId}`, config);

          if (response.status === 200) {
            const userData = response.data.data;

            setAccount({
              displayName: userData.fullName,
              email: userData.email,
              photoURL: '/assets/images/avatars/usericon4.jpeg',
              isOldUser: userData.purchaseSubscription,
            });
          } else {
            console.error('Request failed with status:', response.status);
          }
        } catch (error) {
          console.error('Error fetching user data:', error);
        }
      }
    };

    fetchUserData();
  }, []);

  return account;
};

export default useAccount;
